<template>
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <logo />
      <h2 class="brand-text text-primary ml-2">
        {{ $t('Global.Name') }}
      </h2>
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          {{ $t('Error.TokenInvalid.Title') }}
        </h2>
        <p class="mb-2">
          {{ $t('Error.TokenInvalid.Message') }}
        </p>
        <b-img
          fluid
          :src="require('@/assets/images/pages/not-authorized.svg')"
          alt="Not authorized page"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { BLink, BImg } from 'bootstrap-vue'
import Logo from '@core/layouts/components/Logo.vue'

export default {
  components: {
    BLink,
    BImg,
    Logo,
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
